import styled from "styled-components";

export const StoreSelectionStyled = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
